import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { bootstrapTheme } from "@/hooks/useTheme";
import { bootstrapFontScale } from "@/hooks/useFontScale";

// Apply saved theme (or system preference) BEFORE React mounts, to avoid flash.
bootstrapTheme();
bootstrapFontScale();

// ResizeObserver "loop completed" é um falso-positivo benigno do browser que só
// polui o overlay de erros em dev (e pode sobrepor cliques). Suprimir só ele.
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver")) e.stopImmediatePropagation();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Fade out the initial splash screen once React has mounted.
requestAnimationFrame(() => {
  setTimeout(() => {
    const splash = document.getElementById("gp-splash");
    if (splash) {
      splash.classList.add("gp-out");
      setTimeout(() => splash.remove(), 700);
    }
  }, 550);
});

// -------- PWA: register the Service Worker --------
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => console.warn("SW register failed", err));
  });
}
